import { render, staticRenderFns } from "./ViewByBroker.vue?vue&type=template&id=0540bebc&"
import script from "./ViewByBroker.vue?vue&type=script&lang=js&"
export * from "./ViewByBroker.vue?vue&type=script&lang=js&"
import style0 from "./ViewByBroker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports